import { Order } from 'shell/view-models/order';
import { paginationListToQueryStringForBatchAndEventManager } from 'system/utils/event-batch/list-object-to-query-string-batch-event';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { PublishedEventForm } from '.';

export const transformDataset = (values: PublishedEventForm): string => {
  const { orders, page, rowsPerPage, ...otherValues } = values;

  const transformedFilters: OperationObject = {
    idEventoPubblicato: {
      value: otherValues?.id || '',
    },
  };

  const ordersToTransform = orders || {};
  const ordersMapped: Order = {
    id: ordersToTransform.id,
    fineElaborazione: ordersToTransform.dataTimeConsummation,
    'iscrizioneEvento.tipoDestinazione.codice': ordersToTransform?.typeDestination,
    'iscrizioneEvento.sottoscrittore.codice': ordersToTransform?.subscriber,
    'iscrizioneEvento.id.progressivo': ordersToTransform?.progressive,
    statoElaborazione: ordersToTransform.state,
  };

  return `${paginationListToQueryStringForBatchAndEventManager({
    filters: transformedFilters,
    orders: ordersMapped,
    page,
    rowsPerPage,
  })}`;
};
